<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-row v-if="item">

            <van-collapse v-model="activeNames" class="pro-hd">
                <van-collapse-item title="出库单明细信息" name="22">
                    <div class="pro-item">
                        <van-cell title="出库单号" :value="item.delivery_order_no" style="margin-right: 2px"/>
                        <van-cell title="是否使用价目表价格" :value="item.has_erp_price"/>
                        <van-cell title="是否需要财务审核" :value="item.need_fm"/>
                        <van-cell title="出库单状态" :value="item.deliveryStatusName"/>
                        <van-cell title="是否已到货" :value="item.reached"/>

                    </div>
                    <van-row style="color: #3C6EEB;margin-left: 10px;font-size: 14px">商品信息</van-row>
                    <div v-for="(good,index) in delverygoods">
                        <van-row>{{good.goods_name}}</van-row>
                        <!--<van-col span="10" class="jump-cart-item-img">-->
                        <!--<img :src="good.goodsPic"/>-->
                        <!--</van-col>-->
                        <van-col span="24" class="jump-cart-item-warp">
                            <van-row v-if="!data.rmPass">
                                <van-field
                                        v-model="delivery_price[index]"
                                        label="出库单价"
                                        placeholder="请输入出库单价"
                                        @blur="deliveryPrice"
                                />
                            </van-row>
                            <van-row v-else>
                                <van-field
                                        v-model="delivery_price[index]"
                                        label="出库单价"
                                        placeholder="请输入出库单价"
                                        readonly
                                />
                            </van-row>
                            <!--<p>价目表价格：{{good.erp_Price}}</p>-->
                            <van-field
                                    :value="good.goods_out_code"
                                    label="出库编码"
                                    readonly
                            />
                            <!-- 非入库流程 ，贸易确认到货量 不能修改本次出库数量 
                            第一步 确认出库，只显示本次出库数量，第二步，贸易审核，只能修改实际到货量，第三步。扣款发货，只能修改实际到货量-->
                            <p v-if="workFlow.workflowType==10||(workFlow.workflowType==4&&(data.deliveryGoodsorder.delivery_goodsorder_status==2||data.deliveryGoodsorder.delivery_goodsorder_status==3))||data.deliveryGoodsorder.delivery_goodsorder_status==10">
                                <van-field
                                        :value="out_count[index]"
                                        label="本次出库数量"
                                        readonly
                                />
                            </p>
                            <p v-else>
                                <van-field
                                        v-model="out_count[index]"
                                        label="本次出库数量"
                                        placeholder="请输入本次出库数量"
                                        @blur="outCount"
                                />
                            </p>
                            <p v-if="workFlow.workflowType==4 || workFlow.workflowType==10">
                                <van-row v-if="data.delivery_status!=''&&data.delivery_status==0">
                                    <van-field
                                            :value="receivedCount[index]"
                                            label="实际到货数量"
                                            readonly
                                    />
                                </van-row>
                                <!-- delivery_goodsorder_status=3 是流程全完 -->
                                <van-row v-if="data.deliveryGoodsorder.delivery_goodsorder_status!=1&&data.deliveryGoodsorder.delivery_goodsorder_status!=3">
                                    <van-field
                                            v-model="receivedCount[index]"
                                            label="实际到货数量"
                                            @blur="outCount"
                                    />
                                </van-row>
                            </p>
                              <p v-if="workFlow.workflowType==10">
                                  <van-field
                                        :value="good.supplierCode"
                                        label="供应商"
                                        readonly
                                />
                              </p>
                            <p v-else>
                                <van-field
                                        :value="good.dictdata_value"
                                        label="供货商"
                                        readonly
                                />
                            </p>
                            <p v-if="good.goodsType==1">
                                <van-field
                                        :value="good.erporjxc_name"
                                        label="同步"
                                        readonly
                                />
                            </p>
                            <p v-if="workFlow.workflowType==10">
                                <van-field
                                        :value="good.contract_name"
                                        label="执行合同"
                                        readonly
                                />
                            </p>

                        </van-col>
                    </div>
                </van-collapse-item>
            </van-collapse>

            <van-collapse v-model="erpinfo" class="pro-hd" v-if="delivery.erpInfo!=null">
                <van-collapse-item title="订单类型及发货信息" name="1">
                    <van-row>
                        <p>业务实体：{{delivery.erpInfo.cux_ou_name}}</p>
                        <p>库存组织：{{delivery.erpInfo.warehouse_name}}</p>
                        <p>订单类型：{{delivery.erpInfo.business_type_name}}</p>
                        <p>付款条件：{{delivery.erpInfo.payment_term_name}}</p>
                        <p>价目表：{{delivery.erpInfo.price_list_name}}</p>
                        <p>赠品是否同步ERP：{{delivery.erpInfo.syn_gift_erp_name}}</p>
                        <p>同步ERP状态：
                            <van-button type="info" size="mini" class="blues" @click="seeOrderInfo">查看
                            </van-button>
                        </p>
                    </van-row>
                    <van-row v-if="workFlow.workflowType!=2">
                        <p>车次安排：{{delivery.faHuo.train_type_name}}</p>
                        <p>司机手机号：{{delivery.faHuo.mobile_driver}}</p>
                        <p>车牌号：{{delivery.faHuo.plate_no}}</p>
                        <p>发车时间：{{delivery.faHuo.departure_time}}</p>
                        <p>司机姓名：{{delivery.faHuo.driverName}}</p>
                        <p>司机身份证号：{{delivery.faHuo.driverIdnumber}}</p>
                    </van-row>
                </van-collapse-item>
            </van-collapse>

        </van-row>
    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem} from "vant";

    export default {
        name: "userOrderArrival",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem
        },
        props: {
            //发货单商品
            goodsList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            //发货单
            delivery: {},
            workFlow: {},
            data: {}
        },
        watch: {
            goodsList: {
                immediate: true,    // 这句重要
                handler(val) {
                    let that = this
                    var arr = [];
                    let delivery_price = []
                    let out_count = []
                    let receivedCount = []
                    for (var i = 0; i < val.length; i++) {
                        console.log(val)
                        delivery_price[i] = val[i].delivery_price
                        out_count[i] = val[i].out_count
                        receivedCount[i] = val[i].received_count
                        arr.push(val[i]);
                    }
                    that.delivery_price = delivery_price
                    that.out_count = out_count
                    that.receivedCount = receivedCount
                    that.delverygoods = arr;
                    let json = {}
                    json['deliveryPrice'] = this.delivery_price
                    json['outCount'] = this.out_count
                    json['receivedCount'] = this.receivedCount
                    this.$emit('dataJson', json)
                }
            },
            delivery: {
                immediate: true,    // 这句重要
                handler(val) {
                    this.item = val
                }
            }

        },
        data() {
            return {
                erpinfo: ["1"],
                activeNames: ["22"],
                item: {},
                delverygoods: [],
            };
        },
        mounted: function () {

        },

        methods: {
            deliveryPrice() {
                let that = this
                let json = {}
                json['deliveryPrice'] = that.delivery_price
                json['outCount'] = that.out_count
                json['receivedCount'] = that.receivedCount
                this.$emit('dataJson', json)
            },
            outCount() {
                let json = {}
                json['deliveryPrice'] = this.delivery_price
                json['outCount'] = this.out_count
                json['receivedCount'] = this.receivedCount
                this.$emit('dataJson', json)
            },
            seeOrderInfo() {
                let that = this
                that.$router.push({
                    path: '/erporder',
                     query: {
                        id: that.delivery.erpInfo.erpinfoId,
                        deliveryOrderId: that.delivery.id
                    }
                    // query: {
                    //     id: that.delivery.id,
                    //     deliveryOrderId: that.delivery.erpInfo.erpinfoId
                    // }
                })
            }
        },
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;

    .jump-warphd {
        .pro-hd {
            .van-collapse-item__title {
                background-color: #f7f7f7;
                color: @bule-thame;
                .van-cell__value, i {
                    color: @bule-thame;
                }
            }
        }
        .van-collapse-item__content {
            padding: 0;
        }
        .pro-item {
            border-bottom: 5px solid #f7f7f7;
        }
        .p-tol {
            padding: 10px 10px 20px;
            color: @bule-thame;
            font-size: 14px;
            text-align: right;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
        .van-cell:not(:last-child)::after {
            border: none;
        }
        .jump-cart-item-warp {
            color: black;
        }
        p {
            margin-top: 12px;
        }
    }
</style>
